module.exports = __webpack_public_path__ + "img/receive2.5ddeb111.png";